import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { IncidentTypeApiModel, SideEffectsApiModel } from '@app/api/api-models';

@Injectable()
export class IncidentTypesService extends CrudService<IncidentTypeApiModel, string> {
  public apiUrl = 'incident-types';

  public getPrint(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/print`, { responseType: 'blob' });
  }

  public getSideEffects(id: string): Observable<SideEffectsApiModel> {
    return this.http.get<SideEffectsApiModel>(`${this.apiUrl}/${id}/side-effects`);
  }
}
